// Centralized API configuration for frontend
// Update this in one place to switch environments

export const BASE_URL = 'https://social-media-backend.andrewrkloc.workers.dev';

export const apiPost = async (path, body, init = {}) => {
  const response = await fetch(`${BASE_URL}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(init.headers || {})
    },
    body: JSON.stringify(body),
    ...init
  });
  return response.json();
};

export const apiGet = async (path, init = {}) => {
  const response = await fetch(`${BASE_URL}${path}`, {
    method: 'GET',
    ...(init || {})
  });
  return response.json();
};


